module.exports = __webpack_public_path__ + "img/logo@2x.df736918.png";